import React from 'react';
import { Box, Typography, Chip, useTheme } from '@mui/material';
import { KeywordsListProps } from '../types';

const KeywordsList: React.FC<KeywordsListProps> = ({ keywords }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 2 }}>
      <Typography 
        variant="caption" 
        sx={{ 
          fontWeight: 'medium', 
          color: theme.palette.text.secondary,
          display: 'block',
          mb: 1
        }}
      >
        Keywords:
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {(keywords || []).length > 0 ? (
          keywords.map((keyword: string, keywordIndex: number) => (
            <Chip
              key={keywordIndex}
              label={keyword}
              size="small"
              variant="outlined"
              sx={{
                mr: 0.5,
                mb: 0.5,
                backgroundColor: `${theme.palette.primary.main}15`,
                borderColor: theme.palette.primary.light,
                color: theme.palette.primary.dark
              }}
            />
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            No keywords available
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default KeywordsList;
